import { PropsWithChildren } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useUserContext } from '../context/userContext/UserProvider';
import { Role } from '../types/auth/role';

type Props = PropsWithChildren<{
  allowedRoles?: Role[];
  redirectTo?: string;
}>;

const ProtectedRoute = ({ children, allowedRoles, redirectTo = '/profile' }: Props) => {
  const location = useLocation();
  const { isLoggedIn, user } = useUserContext();

  if (!isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles?.length && !allowedRoles.includes(user?.role || 'USER')) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
